import { useUserPermissions } from '@/hooks/Authentication/userPermissions';
import { useModals } from '@/hooks/ModalManager';
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiDotsVerticalRounded } from 'react-icons/bi';

import { useChecklistSummary } from '../useChecklistSummary';

export const TaskOptions: React.FC<{
  onClose: () => void;
  handleDisableTask?: (taskId: string, hideTask: boolean) => void;
}> = ({ onClose, handleDisableTask }) => {
  const { t } = useTranslation();
  const { handleRestart, handleDelete, data } = useChecklistSummary();
  const { checkPermission } = useUserPermissions();
  const modals = useModals();
  const updateStatusMessage =
    data?.status === 'disabled'
      ? {
          title: t('common.activate_task_confirm'),
          body: t('common.tickets_will_appear'),
        }
      : {
          title: t('common.deactivate_task_confirm'),
          body: t('common.tickets_will_stop_appearing'),
        };

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<BiDotsVerticalRounded />}
        variant="outline"
      />
      <MenuList>
        <MenuItem
          isDisabled={data?.status !== 'draft'}
          onClick={() => {
            modals.confirm({
              title: t('common.cancel_task_confirm'),
              body: t('common.action_cannot_undone'),
              onConfirm: handleRestart,
              confirmProps: {
                colorScheme: 'brand',
              },
            });
          }}
        >
          {t('common.cancel_task')}
        </MenuItem>
        <MenuItem
          isDisabled={
            data?.status === 'done'
              ? !checkPermission('admin')
              : !checkPermission('rw')
          }
          onClick={() => {
            modals.confirm({
              title: t('common.delete_task_confirm'),
              body: t('common.action_cannot_undone'),
              onConfirm: async () => {
                handleDelete?.();
                onClose();
              },
              confirmProps: {
                colorScheme: 'brand',
              },
            });
          }}
        >
          {t('common.delete_task')}
        </MenuItem>
        {handleDisableTask && data?.id && data?.status !== 'done' && (
          <MenuItem
            onClick={() => {
              modals.confirm({
                ...updateStatusMessage,
                onConfirm: async () => {
                  handleDisableTask?.(data.id, data.status !== 'disabled');
                  onClose();
                },
                confirmProps: {
                  colorScheme: 'brand',
                },
              });
            }}
          >
            {data?.status !== 'disabled' ? t('common.deactivate_task') : t('common.activate_task')}
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};
